import { Typography, WithStyles, withStyles } from "@material-ui/core";
import { push } from "connected-react-router";
import { values } from "lodash";
import * as React from "react";
import { connect } from "react-redux";
import { compose } from "recompose";
import Caret from "../../components/Caret/Caret";
import QuotationForm from "../../components/QuotationForm/QuotationForm";
import { getProductDico } from "../../helper/functions.helper";
import { User } from "../../models/User.model";
import { setCustomer, setCustomerQuotation } from "../../store/actions";
import { theme } from "../../theme/theme";
import { Customer } from "../../types/Customer";
import { ProductName, ProductVariantName } from "../../types/Products";
import { Quotation } from "../../types/Quotation";
import { RootState } from "../../types/RootState";
import { PageConnected } from "../Page/Page";
import { styles } from "./PageQuotation.style";

interface PageQuotationProps extends WithStyles<typeof styles> {
    name: ProductName;
    variant: ProductVariantName;
    user: User;
    customers: Customer[];
    setCustomer: typeof setCustomer;
    setCustomerQuotation: typeof setCustomerQuotation;
    push: typeof push;
}

class PageQuotation extends React.Component<PageQuotationProps> {
    public onValidate(customer: Customer, quotation: Quotation, isCustomerModifiedOrNew?: boolean) {
        if (isCustomerModifiedOrNew) {
            this.props.setCustomer(customer);
        }
        this.props.setCustomerQuotation({ customerId: customer.id, quotation });
        this.props.push(`/customer/${customer.id}`);
    }

    public render() {
        const { classes, customers, name, variant } = this.props;
        const dico = getProductDico(name, variant);

        return (
            <PageConnected>
                <div className={classes.container}>
                    <header className={classes.header}>
                        <Typography className={classes.title} variant="title">
                            {dico.cover.title}
                        </Typography>
                        <Caret color={theme.palette.primary.main} variant="thick" top={1} bottom={3} />
                    </header>
                    <QuotationForm
                        advisor={this.props.user}
                        customers={customers}
                        productName={name}
                        productVariantName={variant}
                        onValidate={this.onValidate.bind(this)}
                    />
                </div>
            </PageConnected>
        );
    }
}

export const PageQuotationConnected = compose(
    withStyles(styles, { withTheme: true }),
    connect(
        (state: RootState, ownProps: PageQuotationProps) => ({
            ...ownProps,
            user: state.me.user,
            customers: state.me.userData ? values(state.me.userData.customers) : [],
        }),
        { push, setCustomer, setCustomerQuotation }
    )
)(PageQuotation);

// For stories
export const PageQuotationStyled = withStyles(styles, { withTheme: true })(PageQuotation);



// WEBPACK FOOTER //
// ./src/pages/PageQuotation/PageQuotation.tsx